var _rect, _path, _g, _ellipse, _ellipse2, _ellipse3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconBoat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 63,
    height: 63,
    rx: 10,
    fill: "#00397D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1765_209",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 10,
    width: 41,
    height: 42
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 10.9999H52.749V51.7489H12V10.9999Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1765_209)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.6137 48.3143C49.1877 47.0767 50.4118 45.3857 51.0763 43.3925H15.5801L17.1545 48.1158",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6137 48.3143C49.1877 47.0767 50.4118 45.3857 51.0763 43.3925H15.5801L17.1545 48.1158",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.373 38.6172V43.3925",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 50.5552H13.1938C14.1037 50.5552 15.0135 50.1292 15.5815 49.2773C16.7173 47.5736 19.3005 47.5736 20.4363 49.2773C21.5721 50.9811 24.0758 50.9811 25.2116 49.2773C26.3474 47.5736 28.8511 47.5736 29.9869 49.2773C31.1227 50.9811 33.6263 50.9811 34.7621 49.2773C35.8979 47.5736 38.4016 47.5736 39.5374 49.2773C40.6732 50.9811 43.1769 50.9811 44.3127 49.2773C45.4485 47.5736 48.0318 47.5736 49.1676 49.2773C49.7355 50.1292 50.6453 50.5552 51.5552 50.5552H52.749",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9195 38.6169H17.9688C27.8648 33.8219 33.7004 24.4311 32.3742 13.5149C41.0168 19.5271 46.4038 28.0956 46.7796 38.6169H31.9195Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 23.269,
    cy: 48.2811,
    rx: 2.601,
    ry: 1.734,
    fill: "white"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.9428,
    cy: 48.2811,
    rx: 2.601,
    ry: 1.734,
    fill: "white"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 42.3412,
    cy: 48.2811,
    rx: 2.601,
    ry: 1.734,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBoat);
export default __webpack_public_path__ + "static/media/icon-boat.e2535aa9f9783788d3713d04137bb094.svg";
export { ForwardRef as ReactComponent };